import React from 'react'
import get from 'tcweb-material-components/core/poly/get'
import { domToReact } from 'html-react-parser'
import Typography from '@material-ui/core/Typography'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/styles'

const useClasses = makeStyles((theme) => ({
    headingSwap: ({ data }) => ({
        textTransform: `${get(data, "style.heading.['']", 'capitalize')} !important`,
        fontFamily: `${get(data, "family.font.['']", 'commissioner')} !important`
    })
}))

const HeadingSwap = ({ attribs, className, children, options, data, ...rest }) => {
    const parent = get(children, '[0].parent')
    const variant = get(parent, 'name')
    const isSrOnly = get(data, "only.sr['']")
    const hasAlignment = get(attribs, 'class', '').includes('has-text-align-')
    const _classes = useClasses({ data })
    const _className = classnames(get(attribs, 'class'), className, { 'has-text-align-left': !hasAlignment }, _classes.headingSwap)
    const id = get(attribs, 'id')

    const heading = (
        <Typography {...(!!id ? { id: id } : {})} className={_className} variant={variant}>
            {domToReact(children, options)}
        </Typography>
    )

    if (isSrOnly) {
        return (
            <Typography className={_className} variant='srOnly'>
                {heading}
            </Typography>
        )
    } else {
        return heading
    }
}

export default HeadingSwap
